<template>
  <v-container id="edit-form" fluid>
    <v-card class="sv-card">
      <card-content
        v-resize="onResize"
        :style="{ height: height(170) }"
        class="overflow-y-auto px-0"
      >
        <div class="py-4 px-6">
          <validation-observer ref="validator">
            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-ident"
                  v-model="formData.ident"
                  label="№ гаджета"
                  outlined
                  dense
                  disabled
                  hide-details
                />
              </v-col>
              <v-col>
                <hint
                  text="Порядковый номер соответстует номеру QR-кода, расположенному на гаджете"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-title"
                  v-model="formData.title"
                  label="Название"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-4">
              <v-col cols="11" md="6">
                <div class="d-flex align-center">
                  <v-checkbox
                    id="form-checkbox-gadget-given"
                    v-model="formData.gadget_given"
                    label="Гаджет передан клиенту"
                    hide-details
                    true-value="1"
                    false-value="0"
                    class="mt-0 pt-0"
                  />
                  <hint
                    text="Отметьте, если сувенир был вручен"
                    icon-class="ml-2 mb-2"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row v-if="formData.crmContact" no-gutters class="mt-4">
              <v-col cols="12" class="mb-2">
                <label
                  >QR-код связан с CRM-контактом (<a
                    id="form-btn-cancel"
                    color="primary"
                    depressed
                    outlined
                    class="sv-toggler"
                    @click="onViewCrmContact"
                    >{{ formData.crmContact.fields.title }}</a
                  >)</label
                >
              </v-col>
              <v-col cols="11" md="6">
                <v-btn
                  v-if="!readonly"
                  id="form-btn-save"
                  color="primary"
                  depressed
                  outlined
                  @click="onClickFill"
                >
                  Заполнить данные
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-textarea
                  id="form-text-area-contact-comment"
                  v-model="formData.contact_comment"
                  label="Комментарий"
                  outlined
                  no-resize
                  rows="3"
                  counter="500"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-contact-name"
                  v-model="formData.contact_name"
                  label="Имя клиента"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-contact-company"
                  v-model="formData.contact_company"
                  label="Компания клиента"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-textarea
                  id="form-text-input-contact-data"
                  v-model="formData.contact_data"
                  label="Контактные данные (почта, телефон...)"
                  outlined
                  dense
                  hide-details
                  rows="6"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-contact-data"
                  v-model="formData.hello_msg"
                  label="Приветствие"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col>
                <hint
                  :text="
                    `Текст который идёт после обращения «Welcome!» или «Dear ${formData.contact_name ||
                      'John Doe'}»`
                  "
                />
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-4 mb-6">
              <v-col cols="11" md="6">
                <div class="d-flex align-center">
                  <v-checkbox
                    id="form-checkbox-show-name-in-page"
                    v-model="formData.show_name_in_page"
                    label="Показывать на странице имя"
                    hide-details
                    true-value="1"
                    false-value="0"
                    class="mt-0 pt-0"
                  />
                  <hint
                    text="Если не показывать на странице имя контакта, то в заголовке главного экрана будет написано: «Welcome!»"
                    icon-class="mb-2 ml-2"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row class="mb-6">
              <v-col cols="12" md="6">
                <h2 class="mb-6">Продукты</h2>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="The Offer"
                >
                  <sorter-list
                    v-model="formData.productOfferItems"
                    group-name="products"
                    title="The Offer"
                    class="mb-5"
                    :error-messages="errors"
                    @remove-item="onRemoveProductOffer"
                  />
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="Other products"
                >
                  <sorter-list
                    v-model="formData.productOtherItems"
                    group-name="products"
                    title="Other products"
                    class="mb-5"
                    :error-messages="errors"
                    @remove-item="onRemoveProductOther"
                  />
                </validation-provider>
                <div class="d-flex align-center">
                  <v-btn
                    id="form-btn-add-product-dialog"
                    color="primary"
                    depressed
                    outlined
                    @click="addProductDialog = true"
                  >
                    <v-icon>mdi-plus</v-icon>
                    Продукт
                  </v-btn>
                  <hint
                    text="Выбор из списка всех продуктов, которые есть на сайте"
                    icon-class="ml-2 mb-2"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <h2 class="mb-6">Команда</h2>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="Команда"
                >
                  <sorter-list
                    v-model="formData.personItems"
                    group-name="persons"
                    class="mb-5"
                    :error-messages="errors"
                    @remove-item="onRemovePerson"
                  />
                  <div class="d-flex align-center">
                    <v-btn
                      id="form-btn-add-product-dialog"
                      color="primary"
                      depressed
                      outlined
                      @click="addPersonDialog = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                      Менеджер
                    </v-btn>
                    <hint
                      text="Выбор из списка менеджеров, которые предоставили незашакаленную фотографию"
                      icon-class="ml-2 mb-2"
                    />
                  </div>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <h2 class="mb-6">Данные для отслеживания</h2>
                <div>
                  <tags-editor
                    id="form-autocomplete-tags"
                    v-model="formData.tags"
                    :tag="{
                      name: 'tags',
                      description: 'Тэги',
                      custom_settings: {}
                    }"
                    :dic="dic"
                  />
                </div>
              </v-col>
            </v-row>
          </validation-observer>
        </div>
      </card-content>
      <card-actions>
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="onClickClose"
        >
          {{ readonly ? "Закрыть" : "Отменить" }}
        </v-btn>
        <v-btn
          v-if="!readonly"
          id="form-btn-save"
          color="primary"
          depressed
          outlined
          @click="onClickSave(false)"
        >
          Сохранить
        </v-btn>
        <v-btn
          v-if="!readonly"
          id="form-btn-save"
          color="primary"
          depressed
          @click="onClickSave(true)"
        >
          Сохранить и закрыть
        </v-btn>
        <v-spacer />
        <action-col-btn
          id="btn-www"
          tooltip="Просмотр на сайте"
          :href="monitorLink"
          target="checking-www"
          class="check-www-button"
        >
          mdi-monitor
        </action-col-btn>
      </card-actions>
    </v-card>

    <add-dialog
      v-model="addProductDialog"
      :select-tree="productTree"
      :already-selected-ids="selectedProductIds"
      with-search
      @apply="onAddProducts"
    />

    <add-dialog
      v-model="addPersonDialog"
      :select-tree="personTree"
      :already-selected-ids="selectedPersonIds"
      @apply="onAddPersons"
    />
  </v-container>
</template>
<script>
import { cloneDeep } from "lodash";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import NotificationMixin from "@/mixins/NotificationMixin";
import ResizeMixin from "@/mixins/ResizeMixin";
import SorterList from "@/components/SorterList.vue";
import Hint from "@/components/Hint.vue";
import Repository from "@/api/special/qr-gifts.js";
import AddDialog from "./AddDialog.vue";
import TagsEditor from "../../Node/Editors/TagsEditor.vue";

const formDataFactory = () => ({
  ident: "",
  title: "",
  gadget_given: "0",
  contact_comment: "",
  contact_name: "",
  contact_company: "",
  contact_data: "",
  hello_msg: "",
  show_name_in_page: "0",
  tags: [],
  fulllink: "",
  personItems: [],
  productOfferItems: [],
  productOtherItems: [],
  crmContact: null
});

export default {
  components: {
    SorterList,
    Hint,
    AddDialog,
    TagsEditor
  },
  mixins: [ResizeMixin, NotificationMixin, CheckPermissionMixin],

  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      loading: false,
      addProductDialog: false,
      addPersonDialog: false,
      productTree: { items: [], sections: [] },
      personTree: { items: [], sections: [] },
      formData: formDataFactory()
    };
  },

  computed: {
    readonly() {
      return !this.$can("QrGifts/edit");
    },
    selectedPersonIds() {
      return this.formData.personItems.map(item => item.id);
    },
    selectedProductIds() {
      return this.formData.productOfferItems
        .map(item => item.id)
        .concat(this.formData.productOtherItems.map(item => item.id));
    },
    dic() {
      const dic = this.$store.getters.getDicNames.find(
        dic => dic.name == "qr_tags"
      );
      return this.$store.getters.getDic(dic.id, "en");
    },
    monitorLink() {
      const link = this.formData.fulllink;
      if (link.startsWith("https://")) {
        return link;
      } else {
        return `https://${link}`;
      }
    }
  },

  async created() {
    await this.$store.dispatch("fetchCurrentNode", this.id);
    this.loadItem();
  },

  methods: {
    getTitle(id) {
      const nodeData = this.$store.getters.getNodeFromAnyCache(id) || {};
      return nodeData?.t?.en || `ID ${id}`;
    },
    async loadItem() {
      try {
        this.loading = true;
        const { data } = await Repository.getOne(this.id);
        this.formData = data.formData;
        this.productTree = data.productTree;
        this.personTree = data.personTree;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },

    async onClickSave(close) {
      try {
        if (!(await this.$refs.validator.validate())) {
          const elErrm = document.querySelector(
            ".v-messages.error--text:first-of-type"
          );
          if (elErrm) {
            const elRow = elErrm.closest(".row");
            if (elRow) {
              elRow.scrollIntoView();
            }
          }
          return false;
        }
        const { formData, id } = this;

        const payload = cloneDeep(formData);

        this.loading = true;

        const { data } = await Repository.update(id, payload);

        if (close) {
          this.onClickClose();
        }

        this.sendAlert(data.alert);
      } finally {
        this.loading = false;
      }
    },

    onClickClose() {
      this.$router.push({ name: "QrGifts" });
    },

    onAddProducts(products) {
      const { formData } = this;
      products.forEach(rec => {
        if (formData.productOtherItems.indexOf(rec) < 0) {
          formData.productOtherItems.push(rec);
        }
      });
    },

    onAddPersons(persons) {
      const { formData } = this;
      persons.forEach(rec => {
        if (formData.personItems.indexOf(rec) < 0) {
          formData.personItems.push(rec);
        }
      });
    },

    resetForm() {
      this.formData = formDataFactory();
      if (this.$refs.validator) this.$refs.validator.reset();
    },

    onRemoveProductOffer(item) {
      this.formData.productOfferItems.splice(
        this.formData.productOfferItems.indexOf(item),
        1
      );
    },
    onRemoveProductOther(item) {
      this.formData.productOtherItems.splice(
        this.formData.productOtherItems.indexOf(item),
        1
      );
    },
    onRemovePerson(item) {
      this.formData.personItems.splice(
        this.formData.personItems.indexOf(item),
        1
      );
    },
    onViewCrmContact() {
      this.$router.push({
        name: "CrmContactsEdit",
        params: { id: this.formData.crmContact.id }
      });
    },
    onClickFill() {
      this.formData.contact_name = this.formData.crmContact.fields.title;
      this.formData.contact_company = this.formData.crmContact.fields.company;
      this.formData.contact_data =
        this.formData.crmContact.fields.phones +
        "\r\n" +
        this.formData.crmContact.fields.emails;
    }
  }
};
</script>
